import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SystemInternationalCallsReportParameters } from '@ndt/report-output/system-internation-calls/system-international-calls';
import { createDateRangeReportParameter } from '@ndt/reports/shared/models/date-range-report-parameter-value';
import {
   convertFromFormValueList,
   ParameterFormValueUnion,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-form-value';
import {
   convertToDateRangeReportParameter,
   convertToForm,
   ReportParametersUnion,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-union.model';
import { ReportParameterConfig } from '@ndt/reports/shared/report-parameter-list/report-parameter.config';
import { Reports } from '@ndt/reports/shared/reports.enum';
import { Store } from '@ngrx/store';
import { ReportParameters } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';
import { throwIfNullOrUndefined } from 'src/app/common-components/utils/type-safety';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import {
   ReportParameterFormService,
   ReportParameterFormServiceBase,
} from '../../shared/report-parameter-list/services/report-parameter-form.service';

export class SystemInternationalCallsParametersFormService
   extends ReportParameterFormServiceBase
   implements ReportParameterFormService<SystemInternationalCallsReportParameters>
{
   config: ReportParameterConfig[];

   form: UntypedFormGroup;
   selectedAccountId$: Observable<number | null>;

   constructor(fb: UntypedFormBuilder, private dateAdapter: LcsDateTimeAdapter<Date>, store: Store) {
      super(fb);
      const initialValue: ReportParametersUnion[] = [
         {
            parameterType: ReportParameters.DateRange,
            ...createDateRangeReportParameter(),
            sortOrder: 1,
         },
      ];
      this.selectedAccountId$ = store.select(getSelectedAccountId);

      this.config = initialValue.map((ap) => {
         return this.getReportParameterConfig(ap.parameterType, undefined, false, Reports.SystemInternationalCalls);
      });
      this.form = convertToForm(initialValue, fb);
   }

   patchSavedValues(values: ReportParametersUnion[], showAskToggle: boolean, showAskParameters: boolean): void {
      throw new Error('Method not implemented.');
   }

   resetConfig(): void {
      throw new Error('Method not implemented.');
   }

   setValue(values: ParameterFormValueUnion[]): void {
      this.form.setValue(values, { emitEvent: false });
   }

   getValue(includeAskParameters?: boolean | undefined): SystemInternationalCallsReportParameters | null {
      const formValue = this.form.getRawValue();
      const values: ParameterFormValueUnion[] = formValue.values;
      const convertedValues = convertFromFormValueList(values);
      return this.convertValue(convertedValues);
   }

   convertValue(values: ReportParametersUnion[]): SystemInternationalCallsReportParameters | null {
      const output: SystemInternationalCallsReportParameters = {
         dateRange: throwIfNullOrUndefined(convertToDateRangeReportParameter(values, this.dateAdapter)),
      };
      return output;
   }

   isListComplete(values: ReportParametersUnion[], includeAskParameters = false): boolean {
      const validParameters = !includeAskParameters
         ? values.filter((v) => {
              return !false;
           })
         : values;

      const dateRange = validParameters.find((v) => {
         return v.parameterType === ReportParameters.DateRange;
      });

      return !!dateRange;
   }
}
